// extracted by mini-css-extract-plugin
export var modal = "modal-module--modal--Sm+V6";
export var modal_content = "modal-module--modal_content--GFKTm";
export var modal_top = "modal-module--modal_top--slO4H";
export var title = "modal-module--title--aQqhL";
export var overlay = "modal-module--overlay--iEc3x";
export var close_icon = "modal-module--close_icon--cS1u-";